define(
  'app/views/cart_item_view',['app/setup', 'app/models/cart_item'],
  function(takhfifan, cartItem) {

  takhfifan.CartItemView = takhfifan.BaseView.extend({

    initialize: function(options) {
      var _this = this;
      this.$form = options.form;

      this.$input = $(
        '<input name="cart[' +
        _this.model.get('id') +
        '][qty]" type="hidden">'
      );

      this.$input.val(_this.model.get('quantity'));

      this.$form.append(this.$input);

      this.model.on('change', this.updateCart, this);
    },

    events: {
      'click a.tkh-cart-item-remove' : 'removeItem',
      'click li.tkh-cart-item-quantity-chooser' : 'updateQuantity'
    },

    removeItem: function(event) {
      event.preventDefault();
      var data = JSON.parse(localStorage.getItem("_tkh-customer"));
      if(data && data.data!== null){
        webengage.track("remove_from_cart", {
          "last_name":data.data.name,
          "mobile_number":data.data.mobile,
          "email":data.data.email,
          "customer_id":data.data.id,
        });
      }
      this.setResetSessionFlag();
      window.location.replace($(event.currentTarget).attr('href'));
    },

    updateQuantity: function(event) {
      event.preventDefault();
      var quantity = $(event.target).data('quantity');
      this.model.set('quantity', quantity);
    },

    updateCart: function() {
      this.setResetSessionFlag();
      this.$input.val(this.model.get('quantity'));
      this.$form.submit();
    }

  });

  var $form = $('#tkh-cart-form').first();

  $('.tkh-cart-item').each(function(){
    var $this = $(this);
    var itemId = parseInt($this.data('item-id'));
    var item = new takhfifan.CartItem({
      id: itemId,
      quantity: $this.find('.tkh-cart-item-quantity').first().data('value')
    });
    new takhfifan.CartItemView({
      el: $this,
      model: item,
      form: $form
    });
  });

});

